if (document.querySelector("[data-fancybox]")) {
	Fancybox.bind('[data-fancybox]', {});		
};